import {match} from 'ts-pattern';

import {PostCorrectiveTaxDocumentForCreatingApiResponse} from '@dms/api/sales';

import {AccountingDocumentFormValues} from '../../../types';

export const mapPaymentInfo = (
  data: NonNullable<PostCorrectiveTaxDocumentForCreatingApiResponse>['paymentInfo'] | undefined
): Partial<AccountingDocumentFormValues['paymentInfo']> => {
  if (!data) {
    return {};
  }

  const result: Partial<AccountingDocumentFormValues['paymentInfo']> = {};

  if (data.paymentMethod !== undefined) {
    result.paymentMethod = match(data.paymentMethod)
      .with('INTERNAL', () => 'FREE_OF_CHARGE' as const)
      .otherwise((method) => method);
  }

  if (data.bankAccount !== undefined) {
    result.bankAccount = data.bankAccount;
  }
  if (data.bankName !== undefined) {
    result.bankName = data.bankName;
  }
  if (data.iban !== undefined) {
    result.iban = data.iban;
  }
  if (data.swift !== undefined) {
    result.swift = data.swift;
  }
  if (data.variableSymbol !== undefined) {
    result.variableSymbol = data.variableSymbol;
  }
  if (data.constantSymbol !== undefined) {
    result.constantSymbol = data.constantSymbol;
  }
  if (data.specificSymbol !== undefined) {
    result.specificSymbol = data.specificSymbol;
  }

  return result;
};
